export default "__VITE_ASSET__DoLr5Cch__"